module.exports = __webpack_public_path__ + "img/shuixi09.7384ee73.png";